import type { SxProps, Theme } from '@mui/material';

export const TABBED_PAGE_SHELL_CONTENT_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: 0,
};
